function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_629_"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_494_",
  cx: 255.798,
  cy: 204.54,
  fill: "#ff9171",
  rx: 119.097,
  ry: 119.097,
  transform: "matrix(.707 -.707 .707 .707 -69.71 240.785)"
}), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_2843_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_2844_",
  cx: 128.791,
  cy: 331.546,
  fill: "#b7eabc",
  r: 21.123
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_2841_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_2842_",
  cx: 128.791,
  cy: 331.546,
  fill: "#b7eabc",
  r: 21.123
})), /*#__PURE__*/React.createElement("g", {
  fill: "#b7eabc"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_2830_",
  cx: 255.798,
  cy: 372.013,
  r: 18.105
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_1797_",
  cx: 255.798,
  cy: 372.013,
  r: 18.105
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1768_",
  cx: 255.798,
  cy: 32.59,
  rx: 22.581,
  ry: 22.581,
  transform: "matrix(.987 -.16 .16 .987 -1.917 41.395)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1614_",
  cx: 255.798,
  cy: 32.59,
  rx: 22.581,
  ry: 22.581,
  transform: "matrix(.987 -.16 .16 .987 -1.917 41.395)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1822_",
  cx: 88.324,
  cy: 204.54,
  rx: 18.105,
  ry: 18.105,
  transform: "matrix(.23 -.973 .973 .23 -131.037 243.507)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1821_",
  cx: 88.324,
  cy: 204.54,
  rx: 18.105,
  ry: 18.105,
  transform: "matrix(.23 -.973 .973 .23 -131.037 243.507)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1798_",
  cx: 423.271,
  cy: 204.54,
  rx: 18.105,
  ry: 18.105,
  transform: "matrix(.707 -.707 .707 .707 -20.658 359.206)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1796_",
  cx: 423.271,
  cy: 204.54,
  rx: 18.105,
  ry: 18.105,
  transform: "matrix(.707 -.707 .707 .707 -20.658 359.206)"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1788_"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1791_",
  cx: 374.895,
  cy: 323.637,
  fill: "#b7eabc",
  rx: 21.123,
  ry: 21.123,
  transform: "matrix(.987 -.16 .16 .987 -47 64.23)"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1786_"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1787_",
  cx: 374.895,
  cy: 323.637,
  fill: "#b7eabc",
  rx: 21.123,
  ry: 21.123,
  transform: "matrix(.987 -.16 .16 .987 -47 64.23)"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_179_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_181_",
  cx: 201.117,
  cy: 204.54,
  fill: "#b7eabc",
  r: 21.123
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_177_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_178_",
  cx: 201.117,
  cy: 204.54,
  fill: "#b7eabc",
  r: 21.123
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_204_"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_207_",
  cx: 277.047,
  cy: 162.294,
  fill: "#b7eabc",
  rx: 21.123,
  ry: 21.123,
  transform: "matrix(.987 -.16 .16 .987 -22.419 46.474)"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_185_"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_186_",
  cx: 277.047,
  cy: 162.294,
  fill: "#b7eabc",
  rx: 21.123,
  ry: 21.123,
  transform: "matrix(.987 -.16 .16 .987 -22.419 46.474)"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_212_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_213_",
  cx: 268.406,
  cy: 259.221,
  fill: "#b7eabc",
  r: 21.123
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_210_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_211_",
  cx: 268.406,
  cy: 259.221,
  fill: "#b7eabc",
  r: 21.123
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1843_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_1844_",
  cx: 136.039,
  cy: 84.781,
  fill: "#b7eabc",
  r: 21.123
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1833_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_1842_",
  cx: 136.039,
  cy: 84.781,
  fill: "#b7eabc",
  r: 21.123
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1545_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1828_"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1829_",
  cx: 386.757,
  cy: 73.58,
  fill: "#b7eabc",
  rx: 21.123,
  ry: 21.123,
  transform: "matrix(.924 -.383 .383 .924 1.282 153.607)"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1826_"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_1827_",
  cx: 386.757,
  cy: 73.58,
  fill: "#b7eabc",
  rx: 21.123,
  ry: 21.123,
  transform: "matrix(.924 -.383 .383 .924 1.282 153.607)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_624_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_626_",
  d: "m279.132 420.01c-5.523 0-10 4.478-10 10v72c0 5.523 4.477 10 10 10s10-4.478 10-10v-72c0-5.523-4.477-10-10-10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1032_",
  d: "m58.031 487.455c-3.332 3.022-7.599 4.555-12.682 4.555-13.977 0-25.349-11.663-25.349-26s11.372-26 25.349-26c4.431 0 8.787 1.187 12.598 3.432 4.757 2.801 10.889 1.218 13.692-3.541 2.803-4.758 1.218-10.888-3.541-13.691-6.885-4.056-14.751-6.199-22.749-6.199-25.005-.001-45.349 20.634-45.349 45.999 0 25.364 20.344 46 45.349 46 10.062 0 19.094-3.369 26.12-9.742 4.091-3.711 4.398-10.035.688-14.125-3.711-4.091-10.035-4.4-14.126-.688z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1033_",
  d: "m242.285 420.651c-5.241-1.741-10.901 1.096-12.643 6.338l-15.731 47.354-16.527-47.613c-1.812-5.217-7.509-7.981-12.727-6.168-5.217 1.812-7.979 7.509-6.168 12.727l24.641 70.985c1.645 4.636 6.041 7.735 10.954 7.735h.077c4.944-.033 9.336-3.199 10.952-7.949l23.509-70.767c1.741-5.24-1.096-10.9-6.337-12.642z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1036_",
  d: "m131.211 420.085c-19.152 0-34.734 15.581-34.734 34.733v22.458c0 19.152 15.582 34.733 34.734 34.733s34.733-15.581 34.733-34.733v-22.458c.001-19.152-15.581-34.733-34.733-34.733zm14.734 57.191c0 8.124-6.609 14.733-14.733 14.733s-14.734-6.609-14.734-14.733v-22.458c0-8.124 6.609-14.733 14.734-14.733 8.124 0 14.733 6.609 14.733 14.733z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1037_",
  d: "m417.048 420.01h-12.64c-5.523 0-10 4.478-10 10 0 5.523 4.477 10 10 10h2.64v62c0 5.523 4.477 10 10 10s10-4.478 10-10v-72c0-5.523-4.477-10-10-10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1040_",
  d: "m512.019 451.42c0-16.995-13.826-30.821-30.821-30.821-16.994 0-30.82 13.826-30.82 30.821 0 16.83 13.562 30.544 30.331 30.808-5.26 7.479-10.367 11.474-10.538 11.605-4.396 3.305-5.302 9.544-2.016 13.962 1.963 2.639 4.978 4.033 8.032 4.033 2.075 0 4.167-.644 5.96-1.978 1.035-.77 25.237-19.148 29.487-53.577.251-1.581.385-3.202.385-4.853zm-41.641 0c0-5.967 4.854-10.821 10.82-10.821 5.967 0 10.821 4.854 10.821 10.821s-4.854 10.82-10.821 10.82c-5.966 0-10.82-4.853-10.82-10.82z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1043_",
  d: "m423.272 176.435c-11.976 0-22.22 7.532-26.26 18.105h-12.496c-1.083-14.226-4.485-28.03-10.155-41.155-2.191-5.07-8.077-7.405-13.146-5.214-5.07 2.19-7.404 8.076-5.214 13.146 5.902 13.663 8.895 28.205 8.895 43.224 0 26.485-9.49 50.793-25.244 69.711l-6.297-6.297c-3.905-3.903-10.237-3.904-14.142 0-3.905 3.905-3.906 10.237-.001 14.142l6.297 6.297c-18.918 15.754-43.226 25.244-69.711 25.244s-50.794-9.49-69.711-25.244l.978-.978c3.905-3.905 3.905-10.237 0-14.143-3.905-3.904-10.237-3.904-14.143 0l-.978.978c-15.754-18.918-25.244-43.226-25.244-69.711s9.49-50.793 25.244-69.711l8.226 8.226c1.953 1.953 4.512 2.929 7.071 2.929s5.119-.976 7.071-2.929c3.905-3.905 3.905-10.237 0-14.143l-8.226-8.226c18.918-15.754 43.226-25.244 69.711-25.244 14.865 0 29.27 2.934 42.814 8.719 5.081 2.17 10.955-.19 13.124-5.268 2.17-5.079-.189-10.955-5.268-13.124-12.982-5.545-26.623-8.876-40.671-9.946v-12.228c13.087-4.231 22.58-16.527 22.58-31.005 0-17.965-14.616-32.581-32.58-32.581-17.965 0-32.581 14.616-32.581 32.581 0 14.477 9.494 26.773 22.581 31.005v12.232c-28.091 2.162-53.689 13.358-73.895 30.675l-7.959-7.959c2.056-4.152 3.218-8.823 3.218-13.762 0-17.161-13.961-31.123-31.123-31.123-17.161 0-31.123 13.962-31.123 31.123s13.962 31.123 31.123 31.123c4.939 0 9.61-1.162 13.762-3.218l7.959 7.959c-17.317 20.206-28.513 45.804-30.675 73.895h-12.501c-4.04-10.573-14.284-18.105-26.26-18.105-15.498 0-28.105 12.608-28.105 28.105s12.608 28.105 28.105 28.105c11.976 0 22.22-7.532 26.26-18.105h12.5c2.162 28.091 13.359 53.689 30.676 73.895l-15.207 15.207c-4.152-2.056-8.823-3.218-13.762-3.218-17.161 0-31.123 13.961-31.123 31.122s13.962 31.123 31.123 31.123 31.123-13.962 31.123-31.123c0-4.939-1.162-9.61-3.218-13.762l15.207-15.207c20.207 17.317 45.804 28.513 73.895 30.675v12.501c-10.574 4.04-18.105 14.285-18.105 26.26 0 15.497 12.608 28.105 28.105 28.105s28.105-12.608 28.105-28.105c0-11.976-7.532-22.22-18.105-26.26v-12.501c28.091-2.162 53.688-13.359 73.895-30.675l7.297 7.298c-2.056 4.152-3.218 8.823-3.218 13.762 0 17.161 13.962 31.123 31.123 31.123s31.123-13.962 31.123-31.123-13.961-31.122-31.123-31.122c-4.939 0-9.61 1.162-13.762 3.218l-7.298-7.298c17.317-20.206 28.513-45.804 30.675-73.895h12.5c4.04 10.574 14.284 18.105 26.261 18.105 15.497 0 28.105-12.608 28.105-28.105.002-15.498-12.605-28.105-28.102-28.105zm-167.474-156.425c6.937 0 12.58 5.644 12.58 12.581s-5.643 12.581-12.58 12.581-12.581-5.644-12.581-12.581 5.644-12.581 12.581-12.581zm-119.759 75.894c-6.133 0-11.123-4.99-11.123-11.123s4.99-11.123 11.123-11.123 11.123 4.99 11.123 11.123-4.99 11.123-11.123 11.123zm-47.715 116.741c-4.469 0-8.105-3.636-8.105-8.105s3.636-8.105 8.105-8.105 8.105 3.636 8.105 8.105-3.635 8.105-8.105 8.105zm40.468 130.024c-6.133 0-11.123-4.99-11.123-11.123s4.99-11.122 11.123-11.122 11.123 4.989 11.123 11.122c-.001 6.133-4.991 11.123-11.123 11.123zm127.006 37.45c-4.469 0-8.105-3.636-8.105-8.105s3.636-8.105 8.105-8.105 8.105 3.636 8.105 8.105-3.636 8.105-8.105 8.105zm119.097-67.604c6.133 0 11.123 4.989 11.123 11.122s-4.99 11.123-11.123 11.123-11.123-4.99-11.123-11.123 4.99-11.122 11.123-11.122zm48.377-99.87c-4.469 0-8.106-3.636-8.106-8.105s3.636-8.105 8.106-8.105c4.469 0 8.105 3.636 8.105 8.105-.001 4.469-3.636 8.105-8.105 8.105z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1052_",
  d: "m169.994 204.54c0 17.161 13.962 31.123 31.123 31.123s31.123-13.962 31.123-31.123-13.962-31.123-31.123-31.123-31.123 13.961-31.123 31.123zm42.245 0c0 6.133-4.99 11.123-11.123 11.123s-11.123-4.99-11.123-11.123 4.99-11.123 11.123-11.123 11.123 4.99 11.123 11.123z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1055_",
  d: "m277.047 131.171c-17.161 0-31.123 13.961-31.123 31.123 0 17.161 13.961 31.123 31.123 31.123 17.161 0 31.123-13.962 31.123-31.123s-13.962-31.123-31.123-31.123zm0 42.246c-6.133 0-11.123-4.99-11.123-11.123s4.99-11.123 11.123-11.123 11.123 4.99 11.123 11.123-4.989 11.123-11.123 11.123z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1058_",
  d: "m268.406 228.098c-17.161 0-31.123 13.961-31.123 31.122s13.962 31.123 31.123 31.123 31.122-13.962 31.122-31.123c0-17.16-13.961-31.122-31.122-31.122zm0 42.246c-6.133 0-11.123-4.99-11.123-11.123s4.99-11.122 11.123-11.122 11.122 4.99 11.122 11.122c0 6.133-4.989 11.123-11.122 11.123z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1061_",
  d: "m386.757 104.703c17.161 0 31.123-13.961 31.123-31.123s-13.962-31.123-31.123-31.123-31.122 13.962-31.122 31.123 13.961 31.123 31.122 31.123zm0-42.245c6.133 0 11.123 4.99 11.123 11.123s-4.99 11.123-11.123 11.123-11.122-4.99-11.122-11.123c-.001-6.134 4.989-11.123 11.122-11.123z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1062_",
  d: "m339.84 130.16c2.63 0 5.21-1.07 7.07-2.93s2.93-4.44 2.93-7.08c0-2.63-1.07-5.21-2.93-7.07s-4.44-2.93-7.07-2.93-5.21 1.07-7.07 2.93-2.93 4.44-2.93 7.07c0 2.64 1.07 5.22 2.93 7.08 1.86 1.859 4.44 2.93 7.07 2.93z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1065_",
  d: "m335.332 420.01h-16.2c-2.655 0-5.202 1.057-7.078 2.936-1.876 1.88-2.927 4.428-2.922 7.083v72.017c.01 2.655 1.221 5.197 3.106 7.066 1.873 1.857 4.404 2.898 7.04 2.898h.052c.445-.003 10.964-.059 16.773-.16 22.195-.388 38.304-19.667 38.304-45.84.001-27.514-15.702-46-39.075-46zm.422 71.844c-1.823.031-4.165.059-6.51.082-.027-8.445-.079-43.13-.094-51.926h6.182c17.7 0 19.076 19.9 19.076 26 0 12.701-5.768 25.618-18.654 25.844z"
})));

var SvgCoronavirus = function SvgCoronavirus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.019 512.019",
    height: 512,
    viewBox: "0 0 512.019 512.019",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoronavirus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coronavirus.e326018f.svg";
export { ForwardRef as ReactComponent };